/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const confirmRoutineChangeBodyChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const confirmRoutineChangeBodyChangeStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const confirmRoutineChangeBodyChangeAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const confirmRoutineChangeBodyChangeRotationCountExclusiveMin = 0;
export const confirmRoutineChangeBodyChangeRotationCountMax = 2147483647;

export const confirmRoutineChangeBodyChangeParticipantsItemOrdinalMin = 0;
export const confirmRoutineChangeBodyChangeParticipantsItemOrdinalMax = 19;

export const confirmRoutineChangeBodyChangeParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const confirmRoutineChangeBodyChangeParticipantsMax = 20;

export const confirmRoutineChangeBodyChangeRotationChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const confirmRoutineChangeBodyChangeEndedAtOneOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemStartWeekdayMax = 7;

export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin = 0;
export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax = 1439;

export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemEndWeekdayMax = 7;

export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin = 0;
export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax = 1439;

export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemFullWeekDefault = false;
export const confirmRoutineChangeBodyChangeSectionChangeOneSectionsMax = 14;

export const confirmRoutineChangeBodyChangeSectionChangeOneTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const confirmRoutineChangeBodyChangeSectionChangeOneEffectiveLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const confirmRoutineChangeBodyExpectedVersionExclusiveMin = 0;
export const confirmRoutineChangeBodyExpectedVersionMax = 9007199254740991;

export const confirmRoutineChangeBodyPreviewFingerprintMax = 256;

export const confirmRoutineChangeBodyConfirmNewGapsDefault = false;
export const ConfirmRoutineChangeBody = zod.object({
  change: zod.object({
    teamId: zod.unknown().optional(),
    scheduleId: zod.unknown().optional(),
    timeZone: zod.unknown().optional(),
    timing: zod
      .union([
        zod.object({
          mode: zod.literal('immediate'),
        }),
        zod.object({
          mode: zod.literal('cycle'),
        }),
        zod.object({
          mode: zod.literal('date'),
          localDate: zod.iso.date().regex(confirmRoutineChangeBodyChangeTimingThreeLocalDateRegExp),
        }),
      ])
      .optional(),
    name: zod.string().optional(),
    startLocalDate: zod.iso
      .date()
      .regex(confirmRoutineChangeBodyChangeStartLocalDateRegExp)
      .optional(),
    anchorClockLocal: zod
      .string()
      .regex(confirmRoutineChangeBodyChangeAnchorClockLocalRegExp)
      .optional(),
    rotation: zod
      .object({
        unit: zod.enum(['day', 'week']),
        count: zod
          .int()
          .gt(confirmRoutineChangeBodyChangeRotationCountExclusiveMin)
          .max(confirmRoutineChangeBodyChangeRotationCountMax),
      })
      .optional(),
    participants: zod
      .array(
        zod.object({
          ordinal: zod
            .int()
            .min(confirmRoutineChangeBodyChangeParticipantsItemOrdinalMin)
            .max(confirmRoutineChangeBodyChangeParticipantsItemOrdinalMax),
          userId: zod.uuid().regex(confirmRoutineChangeBodyChangeParticipantsItemUserIdRegExp),
        }),
      )
      .min(1)
      .max(confirmRoutineChangeBodyChangeParticipantsMax)
      .optional(),
    effectiveLocalDate: zod.unknown().optional(),
    rotationChange: zod
      .object({
        action: zod.enum(['set', 'revise', 'cancel']),
        timing: zod
          .union([
            zod.object({
              mode: zod.literal('immediate'),
            }),
            zod.object({
              mode: zod.literal('cycle'),
            }),
            zod.object({
              mode: zod.literal('date'),
              localDate: zod.iso
                .date()
                .regex(confirmRoutineChangeBodyChangeRotationChangeTimingThreeLocalDateRegExp),
            }),
          ])
          .optional(),
        effectiveLocalDate: zod.unknown().optional(),
      })
      .optional(),
    endedAt: zod
      .union([
        zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(confirmRoutineChangeBodyChangeEndedAtOneOneRegExp),
          zod.literal('now'),
        ]),
        zod.null(),
      ])
      .optional(),
    sectionChange: zod
      .union([
        zod.object({
          action: zod.enum(['set', 'revise']),
          sections: zod
            .array(
              zod.object({
                startWeekday: zod
                  .int()
                  .min(1)
                  .max(confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemStartWeekdayMax),
                startLocalMinute: zod
                  .int()
                  .min(
                    confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin,
                  )
                  .max(
                    confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax,
                  ),
                endWeekday: zod
                  .int()
                  .min(1)
                  .max(confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemEndWeekdayMax),
                endLocalMinute: zod
                  .int()
                  .min(confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin)
                  .max(confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax),
                fullWeek: zod
                  .boolean()
                  .default(
                    confirmRoutineChangeBodyChangeSectionChangeOneSectionsItemFullWeekDefault,
                  ),
              }),
            )
            .min(1)
            .max(confirmRoutineChangeBodyChangeSectionChangeOneSectionsMax),
          timing: zod
            .union([
              zod.object({
                mode: zod.literal('immediate'),
              }),
              zod.object({
                mode: zod.literal('cycle'),
              }),
              zod.object({
                mode: zod.literal('date'),
                localDate: zod.iso
                  .date()
                  .regex(confirmRoutineChangeBodyChangeSectionChangeOneTimingThreeLocalDateRegExp),
              }),
            ])
            .optional(),
          effectiveLocalDate: zod.iso
            .date()
            .regex(confirmRoutineChangeBodyChangeSectionChangeOneEffectiveLocalDateRegExp)
            .optional(),
        }),
        zod.object({
          action: zod.literal('cancel'),
        }),
      ])
      .optional(),
  }),
  expectedVersion: zod
    .int()
    .gt(confirmRoutineChangeBodyExpectedVersionExclusiveMin)
    .max(confirmRoutineChangeBodyExpectedVersionMax),
  previewFingerprint: zod.string().min(1).max(confirmRoutineChangeBodyPreviewFingerprintMax),
  confirmNewGaps: zod.boolean().default(confirmRoutineChangeBodyConfirmNewGapsDefault),
});

export type ConfirmRoutineChangeBody = zod.input<typeof ConfirmRoutineChangeBody>;
export type ConfirmRoutineChangeBodyOutput = zod.output<typeof ConfirmRoutineChangeBody>;
